import React from "react";

export default function Footer({systemSettings}) {
  const mainBackground = systemSettings?.mainBackground;

  return (
    <>
      <footer className={`relative bg-[${mainBackground}] pt-8 pb-6`}>
     
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap text-center lg:text-left">
            <div className="w-full lg:w-6/12 px-4">
              <div className="mt-6 lg:mb-0 mb-6">
              </div>
            </div>
          </div>
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-6/12 px-4 mx-auto text-center">
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
